import { type ObjectValuesUnionType } from '../../utils/typing';

export const HistoryActionTypes = Object.freeze({
  SET_FILTER: 'history/setFilter',
  SET_PERIOD_START: 'history/setPeriodStart',
  SET_PERIOD_END: 'history/setPeriodEnd',
  SET_BETSLIP_TYPE: 'history/setBetslipType',
  NEXT_OFFSET: 'history/nextOffset',
  PREV_OFFSET: 'history/prevOffset',
  SET_OFFSET: 'history/setOffset',
  INIT: 'history/init',
  SET_IS_LOADING: 'history/isLoading',
});

export type HistoryActionType = ObjectValuesUnionType<typeof HistoryActionTypes>;
